import { withAlert } from 'react-alert';
import {
  Button as BootstrapButton,
  Form,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import classNames from 'classnames';
import I18n from 'i18n-js';
import { object, oneOf, shape, string } from 'prop-types';

import Alert from '~/components/Alert';
import ShareAndroidIcon from '~/components/atoms/Icons/ShareAndroidIcon';

const SharePopup = ({ item, alert, itemName, className }) => {
  if (!item) {
    return null;
  }
  const { _id, title, name = title } = item;
  const host =
    window.location.href &&
    window.location.href.indexOf('www.lootboy.com') !== -1
      ? 'www.lootboy.com'
      : 'www.lootboy.de';
  const url = `https://${host}/${itemName}s/${_id}`;
  const shareText = `${name}\n${url}`;
  const overlay = (
    <Popover
      className={classNames('sharePopup')}
      id="popover-positioned-bottom"
    >
      <Popover.Title as="h3">
        {I18n.t(`common_share_${itemName}`)}
      </Popover.Title>
      <Popover.Content>
        {I18n.t(`CardDetailView_action_share_${itemName}_web`)}
        <Form.Control
          as="textarea"
          readOnly
          value={shareText}
        />
        <CopyToClipboard
          onCopy={() =>
            alert.info(
              <Alert
                body={I18n.t('common_copied_to_clipboard_msg')}
                title={I18n.t('common_copied_to_clipboard_title')}
              />,
            )
          }
          text={shareText}
        >
          <BootstrapButton variant="primary">
            {I18n.t('common_copy_to_clipboard')}
          </BootstrapButton>
        </CopyToClipboard>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      overlay={overlay}
      placement="bottom"
      trigger="click"
    >
      <ShareAndroidIcon
        className={classNames('navigationBarShareButton', className)}
      />
    </OverlayTrigger>
  );
};

SharePopup.propTypes = {
  alert: object.isRequired,
  item: shape({
    _id: string.isRequired,
    title: string,
    name: string,
  }),
  itemName: oneOf(['loot', 'comic']),
  className: string,
};

export default withAlert()(SharePopup);
